<template>
	<div>
    <base-banner
			:title="banner.title"
			:caption="banner.caption"
			:backgroundImage="banner.image"
			:titleColor="banner.titleColor"
			:captionColor="banner.captionColor"
			:backgroundColor="banner.backgroundColor"
      :buttons="banner.buttons"
		>
		</base-banner>

    <base-goto :breadcrumbs="breadcrumbs"></base-goto>

    <div id="content">
      <div id="assignment" class="sec">
        <v-container>
          <!-- title -->
          <v-row justify="center">
            <div class="display-2 head">Assignment for Individual plus Parents</div>
          </v-row>

          <v-row>
            <v-col
              cols="4"
              v-for="(keyAssignment, key) in keyAssignments"
              :key="key"
            >
              <key-assignment-card
                :title="keyAssignment.title"
                :age-rules="keyAssignment.rules"
                :message="keyAssignment.message"
                :loading="keyAssignment.loading"
                :status="keyAssignment.status"
                :ref="`assignmentForm-${key}`"
              >
                <template v-if="keyAssignment.canRemove" v-slot:action-button>
                  <v-btn
                    small
                    icon
                    @click="keyAssignments.splice(key, 1)"
                    class="ml-auto"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
              </key-assignment-card>
            </v-col>
          </v-row>

          <!-- submit -->
          <v-row class="mt-5">
            <v-col cols="12">
              <v-btn
                rounded
                block
                depressed
                color="primary"
                large
                @click="confirmSubmit()"
              >
                Assign Keys
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>

    <base-confirm-dialog
			v-model="confirmDialog"
			title="Confirm"
			message="Would you like to send a key assignment request?"
			@do="submit()"
		></base-confirm-dialog>
  </div>
</template>

<script>
import Repository from "@/api/repositories";
const ShopAssignmentBannersApi = Repository.get("shopAssignmentBanners");
const KeyAssignmentApi = Repository.get("keyAssignments");
import KeyAssignmentCard from "@/components/key-assignment/cards/AssignmentCard.vue";

export default {
  name: "ShopAssignmentSingle",
  components: {
    KeyAssignmentCard
  },
  data: () => ({
    banner: [],
    breadcrumbs: [
      {
        name: "Medgate",
        link: "/",
        active: false
      },
      {
        name: "Shop",
        link: "/shop",
        active: false
      },
      {
        name: "Key Assignment - Single",
        link: "/shop/keyassignmentsingle",
        active: true
      },
    ],
    keyAssignments: [],
    confirmDialog: false
  }),
  methods: {
    setHeaderColor() {
      if (this.banner.backgroundColor)
        this.$store.commit('page/setHeaderColor', this.banner.backgroundColor)
      else
        this.$store.commit('page/defaultHeaderColor')
    },
    async getAssignmentBanner() {
      try {
        const { data } = await ShopAssignmentBannersApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
            return a.precedence - b.precedence;
          });
          
          let apiData = data.data[0];

          let buttons = apiData.buttons.map(button => {
            return {
              name: button.label,
              icon: button.image,
              link: button.redirect,
              color: JSON.parse(button.styling).color
            }
          });

          let banner = {
            buttons: buttons,
            image: apiData.background_image.main,
            caption: apiData.caption,
            title: apiData.title,
            titleColor: apiData.styles.titleColor,
            captionColor: apiData.styles.captionColor,
            backgroundColor: apiData.styles.backgroundColor
          }

          this.banner = banner;
        }
      }
      catch(error) {
        console.log(error);
      }
    },
    setKeyAssignments() {
      let keyAssignments = [
        {
          title: "Myself",
          rules: this.MIXINS_ABOVE_18_RULES,
          canRemove: false,
          message: "",
          loading: false,
          status: false
        },
        {
          title: "Mother",
          rules: this.MIXINS_ABOVE_18_RULES,
          canRemove: false,
          message: "",
          loading: false,
          status: false
        },
        {
          title: "Father",
          rules: this.MIXINS_ABOVE_18_RULES,
          canRemove: false,
          message: "",
          loading: false,
          status: false
        }
      ];

      this.keyAssignments = keyAssignments;
    },
    getKeyAssignmentsDetails() {
      let forms = [];

      let saveKeyAssignments = false;
      
      for (let index = 0; index < this.keyAssignments.length; index++) {
        let assignmentForm = this.$refs[`assignmentForm-${index}`][0];

        let valid = assignmentForm.validateForm();

        if (valid) {
          let form = assignmentForm.getFormData();

          forms.push({
            first_name: form.firstName,
            middle_name: form.middleName,
            last_name: form.lastName,
            birthdate: form.birthdate,
            email: form.emailAddress,
            phone_number: form.contactNumber,
            access_key: form.accessKey,
            activation_code: form.activationCode,
            employee: form.employee
          });

          saveKeyAssignments = true;

          continue;
        }

        saveKeyAssignments = false;

        break;
      }

      return {
        forms,
        valid: saveKeyAssignments
      }
    },
    confirmSubmit() {
      let keyAssignmentDetails = this.getKeyAssignmentsDetails();

      if (keyAssignmentDetails.valid) {
        this.confirmDialog = true;
      }
    },
    async submit() {
      let keyAssignmentDetails = this.getKeyAssignmentsDetails();

      if (keyAssignmentDetails.valid) {
        for (let index = 0; index < keyAssignmentDetails.forms.length; index++) {
          const form = keyAssignmentDetails.forms[index];

          this.keyAssignments[index].loading = true;

          await KeyAssignmentApi
            .create(form)
            .then(() => {
              this.keyAssignments[index].status = true;
              this.keyAssignments[index].message = "Activation successful! You may now start using the service.";
            })
            .catch(error => {
              this.keyAssignments[index].status = false;
              this.keyAssignments[index].message = error.response.data.message;
            })
            .finally(() => {
              this.keyAssignments[index].loading = false;
            });
        }
      }
    }
  },
  async mounted() {
    await this.getAssignmentBanner();
    this.setHeaderColor();
    this.setKeyAssignments();
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";
</style>